<template>
  <!-- ร้านอีเวนต์ (stepActivities): ตอบคำถามทีละข้อ ข้อถัดไปเปิดเมื่อตอบข้อก่อนหน้าแล้ว -->
  <div class="event-steps pa-4">
    <div v-if="loading" class="text-center py-10">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <template v-else-if="steps.length">
      <div class="stepper">
        <template v-for="(s, i) in steps">
          <div :key="'dot' + i" class="step" @click="open(i)">
            <div class="dot" :class="{ done: s.done, current: i === current && !s.done, locked: !canOpen(i) }">
              <v-icon v-if="s.done" small color="white">mdi-check</v-icon>
              <v-icon v-else-if="!canOpen(i)" small color="#9e9e9e">mdi-lock</v-icon>
              <span v-else>{{ i + 1 }}</span>
            </div>
            <div class="label">{{ th ? 'ข้อ' : 'Q' }} {{ i + 1 }}</div>
          </div>
          <div v-if="i < steps.length - 1" :key="'bar' + i" class="bar" :class="{ done: s.done }"></div>
        </template>
      </div>

      <div v-if="allDone" class="card text-center">
        <v-icon size="64" color="#22c55e">mdi-check-decagram</v-icon>
        <div class="q-title mt-2">{{ th ? 'ตอบคำถามครบแล้ว' : 'All questions answered' }}</div>
        <div class="muted mb-4">{{ th ? 'นำคะแนนไปแลกของรางวัลได้เลย' : 'You can now redeem your reward' }}</div>
        <v-btn rounded block color="primary" @click="$router.push('/home')">{{ th ? 'ไปแลกของรางวัล' : 'Redeem reward' }}</v-btn>
      </div>

      <div v-else class="card">
        <div class="d-flex justify-space-between align-center mb-2">
          <span class="chip">{{ th ? 'ข้อ' : 'Question' }} {{ current + 1 }}/{{ steps.length }}</span>
          <span class="coin"><v-icon small color="#f5b301">mdi-circle-multiple</v-icon> {{ step.item.coin }} {{ th ? 'คะแนน' : 'points' }}</span>
        </div>
        <div class="q-title">{{ questionText }}</div>

        <div v-if="step.done" class="answered">
          <v-icon small color="#22c55e">mdi-check-circle</v-icon> {{ th ? 'ตอบข้อนี้แล้ว' : 'Answered' }}
        </div>

        <template v-else>
          <div v-if="kind === 'text'" class="mt-3">
            <v-textarea v-model="text" outlined auto-grow rows="3" hide-details
              :placeholder="th ? 'พิมพ์คำตอบ' : 'Type your answer'"></v-textarea>
          </div>
          <div v-else class="mt-3">
            <div class="muted mb-2">* {{ kind === 'one' ? (th ? 'เลือก 1 คำตอบ' : 'Choose one') : (th ? 'เลือกได้มากกว่า 1 คำตอบ' : 'Choose one or more') }}</div>
            <div v-for="(c, k) in choices" :key="k" class="choice" :class="{ active: picked.includes(c) }" @click="pick(c)">
              <span>{{ label(c) }}</span>
              <v-icon :color="picked.includes(c) ? 'white' : 'grey'">
                {{ picked.includes(c) ? 'mdi-check-circle' : (kind === 'one' ? 'mdi-checkbox-blank-circle-outline' : 'mdi-checkbox-blank-outline') }}
              </v-icon>
            </div>
          </div>
          <v-btn class="mt-4" rounded block color="primary" :disabled="!ready" :loading="sending" @click="send">
            {{ th ? 'ส่งคำตอบ' : 'Submit' }}
          </v-btn>
        </template>
      </div>
    </template>

    <div v-else class="card text-center muted">{{ $t('message.closeActivity') }}</div>

    <v-snackbar v-model="toast" :timeout="2200" color="success" top>{{ toastText }}</v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'EventSteps',
  data () {
    return {
      loading: true,
      sending: false,
      steps: [],
      current: 0,
      text: '',
      picked: [],
      toast: false,
      toastText: '',
      shopId: null,
      profile: {}
    }
  },
  computed: {
    th () {
      return this.$i18n.locale === 'th'
    },
    step () {
      return this.steps[this.current]
    },
    allDone () {
      return this.steps.length > 0 && this.steps.every(s => s.done)
    },
    kind () {
      const t = this.step.item.answerType
      if (t === 'คำตอบแบบ 1 ตัวเลือก') return 'one'
      if (t === 'คำตอบแบบมากกว่า 1 ตัวเลือก') return 'many'
      return 'text'
    },
    choiceRow () {
      // answerChoice = [["คำถาม/question", "ตัวเลือก/choice", ...]] ร้านอีเวนต์ใช้ 1 คำถามต่อกิจกรรม
      const rows = this.step.item.answerChoice ? JSON.parse(this.step.item.answerChoice) : []
      return rows[0] || []
    },
    choices () {
      return this.choiceRow.slice(1)
    },
    questionText () {
      if (this.kind !== 'text') return this.label(this.choiceRow[0] || this.step.item.title)
      const f = this.step.item.field1Title ? JSON.parse(this.step.item.field1Title) : []
      return (this.th ? f[0] : f[1] || f[0]) || this.step.item.title
    },
    ready () {
      return this.kind === 'text' ? this.text.trim().length > 0 : this.picked.length > 0
    }
  },
  async mounted () {
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()
    await this.load()
  },
  methods: {
    ...mapGetters('lineStore', ['getLiffProfile']),
    ...mapGetters('shopStore', ['GET_SHOPID']),
    label (s) {
      const [a, b] = String(s || '').split('/')
      return this.th ? a : (b || a)
    },
    canOpen (i) {
      return this.steps.slice(0, i).every(s => s.done)
    },
    open (i) {
      if (this.canOpen(i)) this.go(i)
    },
    go (i) {
      this.current = i
      this.text = ''
      this.picked = []
    },
    firstOpen () {
      const i = this.steps.findIndex(s => !s.done)
      return i === -1 ? this.steps.length - 1 : i
    },
    async api (method, url, data, activityId) {
      try {
        const res = await axios({
          method,
          url: this.DNS_IP + url,
          data,
          headers: { shopId: this.shopId, lineUserId: this.profile.userId, memberId: this.profile.memberId, activityId }
        })
        return res.data
      } catch (e) {
        console.error(e)
        return null
      }
    },
    async load () {
      this.loading = true
      const list = await this.api('get', '/activity/line/get/font')
      const now = Date.now()
      // API ส่งใหม่สุดก่อน → กลับลำดับให้ข้อ 1 อยู่แรก
      const items = (Array.isArray(list) ? list : [])
        .filter(a => a.type === 'กรอกข้อมูล')
        .filter(a => new Date(a.startDate).getTime() <= now && (!a.endDate || now < new Date(a.endDate).getTime()))
        .reverse()
      this.steps = await Promise.all(items.map(async item => {
        const log = await this.api('get', `/activityLog/line/get?activityId=${item.activityId}&shopId=${item.shopId}&memberId=${this.profile.memberId}`)
        return { item, done: !!log && log.status !== false }
      }))
      this.go(this.firstOpen())
      this.loading = false
    },
    pick (c) {
      if (this.kind === 'one') {
        this.picked = [c]
      } else {
        this.picked = this.picked.includes(c) ? this.picked.filter(p => p !== c) : this.picked.concat(c)
      }
    },
    async send () {
      if (!this.ready || this.sending) return
      this.sending = true
      const item = this.step.item
      const result = await this.api('post', '/activityLog/add', {
        field1Value: this.kind === 'text' ? this.text.trim() : '',
        field2Value: '',
        field3Value: '',
        field4Value: '',
        answerForChoice: this.kind === 'text' ? null : JSON.stringify([[this.choiceRow[0]].concat(this.picked)])
      }, item.activityId)
      this.sending = false
      // ตอบซ้ำ (เคยตอบแล้วจากอีกเครื่อง) ถือว่าผ่านข้อนี้ ไปข้อต่อไปได้
      if (result && (result.status || result.message === 'lineUserId is already')) {
        this.step.done = true
        if (result.status) {
          this.toastText = this.th ? `ได้รับ ${result.coin || item.coin} คะแนน` : `+${result.coin || item.coin} points`
          this.toast = true
        }
        this.go(this.firstOpen())
        return
      }
      Swal.fire({
        title: result && result.message === 'expired' ? (this.th ? 'กิจกรรมนี้หมดเวลาแล้ว' : 'This activity has ended') : (this.th ? 'ส่งคำตอบไม่สำเร็จ ลองอีกครั้ง' : 'Could not submit, please try again'),
        icon: 'error',
        confirmButtonText: this.th ? 'ตกลง' : 'OK'
      })
    }
  }
}
</script>

<style scoped>
.event-steps { max-width: 560px; margin: 0 auto; padding-bottom: 96px !important; }
.stepper { display: flex; align-items: flex-start; margin-bottom: 16px; }
.step { display: flex; flex-direction: column; align-items: center; cursor: pointer; }
.dot { width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; background: #fff; color: #7c3aed; border: 2px solid #7c3aed; }
.dot.current { background: #7c3aed; color: #fff; }
.dot.done { background: #22c55e; border-color: #22c55e; }
.dot.locked { border-color: #d4d4d4; background: #f5f5f5; cursor: default; }
.label { font-size: 12px; margin-top: 4px; color: #555; }
.bar { flex: 1; height: 3px; background: #e0e0e0; margin: 17px 6px 0; border-radius: 2px; }
.bar.done { background: #22c55e; }
.card { background: #fff; border-radius: 16px; padding: 16px; box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
.chip { background: #ede9fe; color: #6d28d9; border-radius: 999px; padding: 2px 10px; font-size: 13px; font-weight: bold; }
.coin { font-size: 13px; color: #555; }
.q-title { font-size: 18px; font-weight: bold; line-height: 1.4; }
.muted { color: #757575; font-size: 13px; }
.answered { margin-top: 12px; color: #16a34a; font-weight: bold; }
.choice { display: flex; justify-content: space-between; align-items: center; gap: 8px; padding: 12px 14px; margin-bottom: 8px; border-radius: 12px; background: #f5f5f5; cursor: pointer; }
.choice.active { background: #7c3aed; color: #fff; }
</style>



// WEBPACK FOOTER //
// src/components/Activity/EventSteps.vue